import { useContext } from "react";
import { IntentsContext } from "@contexts";

export const useIntents = () => useContext(IntentsContext);
